import React, { useState, useEffect } from "react";
import "./WalletRecharge.css";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import riyalSymbol from "./images/riyal_symbol.svg";
import { useTranslation } from "react-i18next";
function WalletRecharge() {
  const {t}=useTranslation('backend');
  const token = Cookies.get("token");
  const [bankDetails, setBankDetails] = useState(null);
  const [walletBalance, setWalletBalance] = useState(null);
  const [formData, setFormData] = useState({
    senderName: "",
    amount: "",
    receipt: null,
  });
  const [userEmail, setUserEmail] = useState("");
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  useEffect(() => {
    if (!token) return;
    const decodedToken = jwtDecode(token);
    setUserEmail(decodedToken.email);
  }, [token]);

  useEffect(() => {
    if (!userEmail) return;
    fetchWallet();
  }, [userEmail]);

  useEffect(() => {
    const fetchBankDetails = async () => {
      try {
        const response = await fetch(`${BASE_URL}/api/bank-details`);
        if (!response.ok) throw new Error("Failed to fetch bank details");
        const data = await response.json();
        setBankDetails(data);
      } catch (error) {
        console.error("Error fetching bank details:", error);
      }
    };

    fetchBankDetails();
  }, []);
  const fetchWallet = async () => {
    try {
      const response = await fetch(`${BASE_URL}/get/wallet/${userEmail}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const result = await response.json();
      if (response.ok) {
        setWalletBalance(result.wallet);
      } else {
        alert(result.error);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value, // Handle file inputs separately
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { senderName, amount, receipt } = formData;

    if (!senderName || !amount || !receipt) {
      alert(t("allFieldsRequire"));
      return;
    }

    const formDataObj = new FormData();
    formDataObj.append("senderName", senderName);
    formDataObj.append("amount", amount);
    formDataObj.append("receipt", receipt);

    try {
      console.log(formDataObj);
      const response = await fetch(
        `${BASE_URL}/api/wallet-recharge/${userEmail}`,
        {
          method: "POST",
          body: formDataObj,
        }
      );

      if (!response.ok) throw new Error("Failed to submit request.");

      alert(t("walletRechargeSuccess"));
      navigate(-1); // Redirect to another page if needed
    } catch (error) {
      console.error("Error submitting wallet recharge request:", error);
    }
  };
  return (
    <div className="wallet-recharge-container">
      <div
        style={{
          padding: "10px",
          border: "1px solid #ddd",
          borderRadius: "8px",
          backgroundColor: "#f9f9f9",
        }}
      >
        <h2 className="wallet-recharge-title">
        {t('wallet_recharge.title')}
        </h2>
        <p className="wallet-recharge-description">
        {t('wallet_recharge.description')}
        </p>

        {bankDetails ? (
          <div className="bank-details">
          <h3 className="bank-details-title">{t('wallet_recharge.bank_details.title')}</h3>
          <div className="bank-details-card">
            <p className="bank-detail">
              <span className="detail-label">{t('wallet_recharge.bank_details.account_name')}:</span>
              <span className="detail-value">{bankDetails.account_name}</span>
            </p>
            <p className="bank-detail">
              <span className="detail-label">{t('wallet_recharge.bank_details.bank_name')}:</span>
              <span className="detail-value">{bankDetails.bank_name}</span>
            </p>
            <p className="bank-detail">
              <span className="detail-label">{t('wallet_recharge.bank_details.account_number')}:</span>
              <span className="detail-value">{bankDetails.account_number}</span>
            </p>
            <p className="bank-detail">
              <span className="detail-label">{t('wallet_recharge.bank_details.iban')}:</span>
              <span className="detail-value">{bankDetails.iban}</span>
            </p>
          </div>
        </div>
        
        ) : (
          <p>{t('wallet_recharge.loading_bank')}</p>
        )}

        <h3 className="form-title">
        {t('wallet_recharge.form.title')}
        </h3>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="senderName">{t('wallet_recharge.form.sender_name')}</label>
            <input
              type="text"
              id="senderName"
              name="senderName"
              value={formData.senderName}
              onChange={handleChange}
              placeholder={t('wallet_recharge.form.enter_sender_name')}
            />
          </div>

          <div className="form-group">
            <label htmlFor="amount">{t('wallet_recharge.form.amount')}</label>
            <input
              type="number"
              id="amount"
              name="amount"
              value={formData.amount}
              onChange={handleChange}
              placeholder={t('wallet_recharge.form.enter_amount')}
            />
          </div>

          <div className="wallet-balance">
            <div className="wallet-balance-container">
              <p className="wallet-balance-text">
              {t('wallet_recharge.form.wallet_balance')}:
                <strong className="wallet-balance-amount">
                 <img src={riyalSymbol} height={"27px"} alt="riyal"></img> {walletBalance} 
                </strong>
              </p>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="receipt">{t('wallet_recharge.form.receipt')}</label>
            <input
              type="file"
              id="receipt"
              name="receipt"
              onChange={handleChange}
              style={{ color: "black" }}
            />
          </div>

          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              gap: "20px",
            }}
          >
            <button
              type="button"
              className="back-button"
              onClick={() => navigate(-1)}
            >
               {t('wallet_recharge.buttons.back')}
            </button>
            <button type="submit" className="confirm-button">
            {t('wallet_recharge.buttons.submit_request')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default WalletRecharge;
